<template>
  <teleport to="body">
    <transition name="modal-fade">
      <div
        v-if="visivel"
        class="termo-overlay"
        role="dialog"
        aria-modal="true"
        aria-labelledby="titulo-termo-modal"
        @click.stop
      >
        <div class="termo-modal-card">
          <!-- Cabeçalho -->
          <div class="termo-header">
            <div class="termo-icone-topo">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="28"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
            </div>

            <div class="termo-titulos">
              <div class="termo-badge-versao" v-if="termo?.versao">
                Versão {{ termo.versao }}
              </div>
              <h2 id="titulo-termo-modal">Termos de Uso e Privacidade</h2>
              <p>
                Para continuar utilizando as funcionalidades da plataforma GEX,
                você precisa ler e concordar com a versão vigente dos documentos
                abaixo.
              </p>
            </div>
          </div>

          <!-- Documentos para Leitura -->
          <div class="termo-documentos-grid">
            <!-- Card Termo de Uso -->
            <div class="documento-card">
              <div class="documento-info">
                <div class="doc-icone">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                    <polyline points="14 2 14 8 20 8" />
                  </svg>
                </div>
                <div>
                  <h4>Termo de Uso do GEX</h4>
                  <p>Regras de utilização, responsabilidades e condições de acesso.</p>
                </div>
              </div>
              <a
                v-if="termo?.termoUsoUrl"
                :href="termo.termoUsoUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="btn-abrir-doc"
              >
                <span>Visualizar PDF</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
              <span v-else class="doc-indisponivel">Documento não anexado</span>
            </div>

            <!-- Card Política de Privacidade -->
            <div class="documento-card">
              <div class="documento-info">
                <div class="doc-icone doc-icone-seguranca">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
                  </svg>
                </div>
                <div>
                  <h4>Política de Privacidade</h4>
                  <p>Dados pessoais, finalidades do tratamento e direitos dos titulares (LGPD).</p>
                </div>
              </div>
              <a
                v-if="termo?.politicaPrivacidadeUrl"
                :href="termo.politicaPrivacidadeUrl"
                target="_blank"
                rel="noopener noreferrer"
                class="btn-abrir-doc"
              >
                <span>Visualizar PDF</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                  <polyline points="15 3 21 3 21 9" />
                  <line x1="10" y1="14" x2="21" y2="3" />
                </svg>
              </a>
              <span v-else class="doc-indisponivel">Documento não anexado</span>
            </div>
          </div>

          <!-- Mensagem de Erro (se houver) -->
          <div v-if="erro" class="termo-erro-msg" role="alert">
            {{ erro }}
          </div>

          <!-- Checkbox de Aceite -->
          <div class="termo-consentimento-box">
            <label class="custom-checkbox-container">
              <input
                type="checkbox"
                v-model="concordou"
                :disabled="salvando"
              />
              <span class="checkmark"></span>
              <span class="checkbox-label">
                Declaro que li e concordo integralmente com os
                <strong>Termos de Uso</strong> e a
                <strong>Política de Privacidade</strong> da plataforma GEX.
              </span>
            </label>
          </div>

          <!-- Rodapé de Ações -->
          <div class="termo-footer">
            <button
              type="button"
              class="btn-termo-sair"
              @click="sairDaConta"
              :disabled="salvando"
            >
              Sair da conta
            </button>

            <button
              type="button"
              class="btn-termo-concordar"
              :disabled="!concordou || salvando"
              @click="salvarConcordancia"
            >
              <span v-if="salvando" class="spinner-border spinner-border-sm me-2" role="status"></span>
              {{ salvando ? "Registrando aceite..." : "Concordar e continuar" }}
            </button>
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script setup>
import { ref, defineProps, defineEmits } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import termoService from "@/service/termoService";

const props = defineProps({
  visivel: {
    type: Boolean,
    default: false,
  },
  termo: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["concordou", "cancelou"]);

const router = useRouter();
const auth = useAuthStore();

const concordou = ref(false);
const salvando = ref(false);
const erro = ref("");

function sairDaConta() {
  auth.finalizarSessao();
  emit("cancelou");
  router.push("/");
}

async function salvarConcordancia() {
  if (!concordou.value) return;

  salvando.value = true;
  erro.value = "";

  try {
    const versao = props.termo?.versao || null;
    const res = await termoService.registrarConcordancia(true, versao);

    // Atualiza o estado da store
    auth.definirStatusTermo(false, {
      ...props.termo,
      usuarioConcordou: true,
      usuarioVersaoConcordada: versao,
      usuarioDataConcordancia: res?.dataConcordancia || new Date().toISOString(),
      precisaConcordar: false,
    });

    emit("concordou", res);
  } catch (err) {
    console.error("Erro ao registrar concordância:", err);
    erro.value =
      err?.response?.data?.message ||
      "Ocorreu um erro ao registrar sua concordância. Por favor, tente novamente.";
  } finally {
    salvando.value = false;
  }
}
</script>

<style scoped>
.termo-overlay {
  position: fixed;
  inset: 0;
  background-color: rgba(18, 12, 38, 0.75);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
}

.termo-modal-card {
  background: var(--branco);
  width: 100%;
  max-width: 620px;
  border-radius: 20px;
  box-shadow: 0 25px 60px -15px rgba(0, 0, 0, 0.35);
  padding: 2.25rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  animation: modal-pop 0.28s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes modal-pop {
  0% {
    opacity: 0;
    transform: scale(0.92) translateY(12px);
  }
  100% {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.termo-header {
  display: flex;
  gap: 1.25rem;
  align-items: flex-start;
}

.termo-icone-topo {
  width: 52px;
  height: 52px;
  border-radius: 14px;
  background: var(--roxo-superficie);
  color: var(--roxo-primario);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.termo-titulos {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
}

.termo-badge-versao {
  align-self: flex-start;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--roxo-primario);
  background: var(--roxo-superficie);
  border: 1px solid rgba(75, 43, 140, 0.2);
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  letter-spacing: 0.5px;
}

.termo-titulos h2 {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--roxo-escuro);
  margin: 0;
  line-height: 1.25;
}

.termo-titulos p {
  font-size: 0.92rem;
  color: var(--cinza-escuro);
  margin: 0;
  line-height: 1.45;
}

.termo-documentos-grid {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.documento-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.15rem;
  border: 1px solid var(--cinza-claro);
  background-color: #faf9fd;
  border-radius: 14px;
  transition: all 0.2s ease;
  gap: 1rem;
}

.documento-card:hover {
  border-color: var(--roxo-claro);
  background-color: #f6f3fc;
  box-shadow: 0 4px 12px rgba(75, 43, 140, 0.06);
}

.documento-info {
  display: flex;
  align-items: center;
  gap: 0.9rem;
}

.doc-icone {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #ede9fe;
  color: var(--roxo-primario);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.doc-icone-seguranca {
  background: #e0f2fe;
  color: #0369a1;
}

.documento-info h4 {
  font-size: 0.98rem;
  font-weight: 600;
  color: var(--roxo-escuro);
  margin: 0 0 0.15rem 0;
}

.documento-info p {
  font-size: 0.82rem;
  color: var(--cinza-medio);
  margin: 0;
  line-height: 1.3;
}

.btn-abrir-doc {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.86rem;
  font-weight: 600;
  color: var(--roxo-medio);
  text-decoration: underline;
  padding: 0.45rem 0.75rem;
  border-radius: 8px;
  background: transparent;
  white-space: nowrap;
  transition: color 0.15s ease;
}

.btn-abrir-doc:hover {
  color: var(--roxo-primario);
}

.doc-indisponivel {
  font-size: 0.82rem;
  color: var(--cinza-medio);
  font-style: italic;
}

.termo-consentimento-box {
  background: #fbfbfe;
  border: 1px solid #e7e5f0;
  border-radius: 12px;
  padding: 1rem 1.15rem;
}

.custom-checkbox-container {
  display: flex;
  align-items: flex-start;
  position: relative;
  cursor: pointer;
  user-select: none;
  gap: 0.75rem;
}

.custom-checkbox-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.checkmark {
  width: 22px;
  height: 22px;
  background-color: var(--branco);
  border: 2px solid var(--cinza-medio);
  border-radius: 6px;
  display: inline-block;
  flex-shrink: 0;
  margin-top: 2px;
  transition: all 0.18s ease;
  position: relative;
}

.custom-checkbox-container:hover input ~ .checkmark {
  border-color: var(--roxo-medio);
}

.custom-checkbox-container input:checked ~ .checkmark {
  background-color: var(--roxo-primario);
  border-color: var(--roxo-primario);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
  left: 6px;
  top: 2px;
  width: 6px;
  height: 12px;
  border: solid white;
  border-width: 0 2.5px 2.5px 0;
  transform: rotate(45deg);
}

.custom-checkbox-container input:checked ~ .checkmark:after {
  display: block;
}

.checkbox-label {
  font-size: 0.9rem;
  color: var(--cinza-escuro);
  line-height: 1.45;
}

.checkbox-label strong {
  color: var(--roxo-escuro);
}

.termo-erro-msg {
  background: var(--vermelho-claro);
  color: var(--vermelho-escuro);
  font-size: 0.88rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(220, 38, 38, 0.2);
}

.termo-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--cinza-claro);
}

.btn-termo-sair {
  background: transparent;
  border: 1px solid #d1d5db;
  color: #4b5563;
  padding: 0.65rem 1.25rem;
  border-radius: 10px;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.btn-termo-sair:hover:not(:disabled) {
  background: #f3f4f6;
  color: var(--vermelho-escuro);
  border-color: #fca5a5;
}

.btn-termo-concordar {
  background: var(--roxo-medio);
  color: var(--branco);
  border: none;
  padding: 0.75rem 1.75rem;
  border-radius: 10px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  box-shadow: 0 4px 12px rgba(75, 43, 140, 0.25);
}

.btn-termo-concordar:hover:not(:disabled) {
  background: var(--roxo-primario);
  box-shadow: 0 6px 16px rgba(75, 43, 140, 0.35);
  transform: translateY(-1px);
}

.btn-termo-concordar:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  box-shadow: none;
  transform: none;
}

/* Transições */
.modal-fade-enter-active,
.modal-fade-leave-active {
  transition: opacity 0.25s ease;
}

.modal-fade-enter-from,
.modal-fade-leave-to {
  opacity: 0;
}

@media (max-width: 600px) {
  .termo-modal-card {
    padding: 1.5rem;
  }
  .termo-footer {
    flex-direction: column-reverse;
  }
  .btn-termo-sair,
  .btn-termo-concordar {
    width: 100%;
  }
}
</style>

